<template>
  <div :style="{height:(treeHeight + 'px'), overflow:'auto'}">
    <Row>
      <Button size="small" @click="onBackupDbClick">创建数据库备份</Button>
    </Row>
    <Row style="margin-top: 5px;">
      <Col span="24">
        <Tree :data="logTreeData" :load-data="onLoadChildrenData" style="overflow: hidden;" :render="renderContent"></Tree>
      </Col>
    </Row>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
  import {numberFormat} from '@/libs/numberutil'
  import Editor from 'wangeditor'
  import 'wangeditor/release/wangEditor.min.css'
  import {oneOf} from '@/libs/tools'

  export default {
    //此名称与routers.js中name一致方可缓存
    name: 'backupdb',
    components: {},
    data() {
      return {
        treeHeight:600,
        logTreeData: [
          {
            id: 1,
            title: 'backups',
            fileType: 2,
            expand: false,
            checked: true,
            selected: true,
            loading: false,
            filePath: null,
            children: []
          }
        ],
      }
    },
    methods: {
      ...mapActions([
        'BackupDbServ_GetChildrenFileList'
      ]),
      onBackupDbClick(){
        this.$Modal.confirm({
          title: '提示',
          content: '确认创建备份',
          onOk: () => {
            store.dispatch('BackupDbServ_MakeBackup', {
              params: null,
              urlparams: null
            }).then(() => {
              this.$Message.success('开始创建备份')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {

          }
        })
      },
      onLoadChildrenData(item, callback) {
        //加载子区域
        let parentDir = item.title === 'backups' ? null : item.title
        store.dispatch('BackupDbServ_GetChildrenFileList', {
          params: null,
          urlparams: {parentDir: parentDir}
        }).then(() => {
          let tempData = [];
          this.tempChildren = store.getters.get_BackupDb_GetChildrenFileListResult ? store.getters.get_BackupDb_GetChildrenFileListResult : [];
          this.tempChildren.forEach((dtoitem, index) => {
            tempData.push({
              id: dtoitem.id,
              title: dtoitem.name,
              fileType: dtoitem.fileType,
              fileSize: dtoitem.size,
              filePath: (item.filePath === null ? dtoitem.name : item.filePath + '/' + dtoitem.name),
              expand: false,
              loading: false,
              children: dtoitem.fileType === 2 ? [] : null,
              parent: item
            })
          })
          callback(tempData)
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      renderContent(h, {root, node, data}) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', [
            h('Icon', {
              props: {
                type: data.fileType === 2 ? 'ios-folder-outline' : 'ios-paper-outline'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h('span', {
              style: {
                // fontSize:'medium',
                // backgroundColor:'#2db7f5',
                // color:'#ffffff'
              },
              on: {
                click: () => {

                }
              }
            }, data.title),
            h('span', {
              style: {
                // fontSize:'medium',
                // backgroundColor:'#2db7f5',
                // color:'#ffffff'
              },
              on: {
                click: () => {

                }
              }
            }, data.fileSize?'[' + data.fileSize + ']':''),
          ]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '20ßpx'
            }
          }, [
            h('Button', {
              props: {
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '确认删除文件',
                    content: '<p>注意：删除文件后不可恢复</p>',
                    onOk: () => {
                      store.dispatch('BackupDbServ_RemoveFile', {
                        params: null,
                        urlparams: {filePath: data.filePath}
                      }).then(() => {
                        let p = data.parent
                        if (p) {
                          let removeIndex = -1;
                          let length = p.children.length
                          for (var i = 0; i < length; i++) {
                            if (p.children[i].filePath === data.filePath) {
                              removeIndex = i
                              break
                            }
                          }
                          if (removeIndex !== -1) {
                            p.children.splice(removeIndex, 1)
                          }
                        }
                        this.$Message.success('删除成功')
                      }).catch(err => {
                        this.$Message.error(err)
                      })
                    },
                    onCancel: () => {
                    }
                  })
                }
              }
            }, '-')
          ])
        ])
      }
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
        window.onresize = () => {
          this.treeHeight = window.innerHeight - 155
        }
        this.treeHeight = window.innerHeight - 155
      })
    }
  }
</script>
<style>

</style>
